import React from 'react'

export default function FormLayout({ title, children }) {
  return (
    <div>
      <h3 className=" font-medium text-gray-700">{title}</h3>
      <div className="mt-1 sm:mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        {children}
      </div>
    </div>
  )
}
